export function normalizeScanValue(value) {
  return String(value || '').trim();
}

export function deviceMatchesScan(device, scanValue) {
  const needle = normalizeScanValue(scanValue).toLowerCase();
  if (!needle) return false;

  const candidates = [
    device?.imei,
    device?.imei_number,
    device?.imeiNumber,
    device?.imeiNo,
    device?.gps_serial_no,
    device?.gpsSerialNo,
    device?.gps_card_no,
    device?.gpsCardNo,
    device?.device_id,
    device?.deviceId,
    device?.id,
    device?._id,
  ]
    .filter(Boolean)
    .map((item) => String(item).toLowerCase());

  return candidates.some(
    (candidate) => candidate === needle || candidate.includes(needle) || needle.includes(candidate)
  );
}

export function findDeviceByScan(devices, scanValue) {
  const list = Array.isArray(devices) ? devices : [];
  return list.find((device) => deviceMatchesScan(device, scanValue)) || null;
}

export function getDeviceSelectValue(device) {
  return device?._id || device?.id || device?.device_id || device?.deviceId || '';
}
